import React, { Component } from 'react';
import { Input, Modal, Button } from 'react-materialize';
import Calendar from 'react-calendar';
import Moment from 'react-moment';
import * as moment from 'moment'

import CommonConstants from '../../constants/CommonConstants';
import EventUtils from '../../utils/EventUtils';
import StringUtils from '../../utils/StringUtils';

import './DatePicker.css';

class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: props.date,
      selectingDate: props.date,
      modalId: `date-picker-modal-${(new Date()).getTime()}`
    };

    this.clear = this.clear.bind(this);
    this._handleInputClick = this._handleInputClick.bind(this);
    this._handleTodayClick = this._handleTodayClick.bind(this);
    this._handleClearClick = this._handleClearClick.bind(this);
    this._handleOkClick = this._handleOkClick.bind(this);
    this._handleCalendarChange = this._handleCalendarChange.bind(this);
  }

  get date() {
    return this.state.date;
  }

  set date(date) {
    this.setState({ date: date }, () => EventUtils.raiseEvent('change', { date: date }, this.props));
  }

  get selectingDate() {
    return this.state.selectingDate;
  }

  set selectingDate(selectingDate) {
    this.setState({ selectingDate: selectingDate });
  }

  clear(reportChange) {
    this.setState({ date: this.props.date }, () => {
      if (reportChange) {
        EventUtils.raiseEvent('change', { date: this.props.date }, this.props);
      }
    });
  }

  _handleInputClick(event) {
    const { modalId, date } = this.state;

    this.setState({ selectingDate: date }, () => {
      window.$(`#${modalId}`).modal('open');
    })
  }

  _handleTodayClick(event) {
    this.selectingDate = new Date();
  }

  _handleClearClick(event) {
    this.selectingDate = null;
  }

  _handleOkClick(event) {
    this.date = this.selectingDate;
  }

  _handleCalendarChange(date) {
    this.selectingDate = date;
  }

  componentWillReceiveProps(props){
      this.setState({ date: props.date, selectingDate: props.date });
  }

  shouldComponentUpdate(props,state){
    if(this.props.date !== state.date && this.props.name === props.name){
      return true;
    }
    return false;
  }

  componentDidMount() {
    window.$('.date-picker-input').attr('disabled', true);
  }

  render() {
    const { date, selectingDate, modalId } = this.state;
    const { label, name, disabled } = this.props;

    let modalActions = (
      <div className="modal-footer-actions">
        <Button flat className="today-btn" waves="light" onClick={ this._handleTodayClick }>Today</Button>
        <Button flat className="clear-btn" waves="light" onClick={ this._handleClearClick }>Clear</Button>
        <Button flat className="ok-btn" modal="close" waves="light" onClick={ this._handleOkClick }>OK</Button>
      </div>
    );

    return (
      <div className="date-picker">
        <Input className="date-picker-input" label={ label } name={ name } disabled={ disabled } onClick={ this._handleInputClick } value={ date ? moment.default(date).format(CommonConstants.NUXEO_DATE_FORMAT) : StringUtils.EMPTY }/>
        <Modal id={ modalId } className="date-picker-modal" actions={ modalActions }>
          <div className="date-picker-modal-header">
            { selectingDate ? <Moment format={ CommonConstants.NUXEO_DATE_FORMAT }>{ selectingDate }</Moment> : <span>None</span> }
          </div>
          <div className="date-picker-modal-body">
            <Calendar value={ selectingDate } onChange={ this._handleCalendarChange }/>
          </div>
        </Modal>
      </div>
    );
  }
}

export default DatePicker;
